import { z } from "zod";
import { useVariableInputStore } from "../../../store/variableInput.store";
import { stringContainsValidVariable } from "../../../utils/node.util";

// Predefined conditions
export const predefinedConditions = z.object({
  field: z.string(),
  operator: z.string(),
  value: z.string().refine((value) => {
    const validVariables = useVariableInputStore.getState().variables;
    return stringContainsValidVariable(value, validVariables);
  }, "Incorrect Variable used"),
});

export type PredefinedConditions = z.infer<typeof predefinedConditions>;

// Custom conditions
export const customConditions = z.object({
  value: z.string().refine((value) => {
    const validVariables = useVariableInputStore.getState().variables;
    return stringContainsValidVariable(value, validVariables);
  }, "Incorrect Variable used"),
});

export type CustomConditions = z.infer<typeof customConditions>;

// Branch node schema
export const branchNodeSchema = z.object({
  nodeId: z.string(),
  name: z.string().min(1, "Please enter valid name"),
  conditions: z.array(
    z.object({
      type: z.enum(["predefined", "custom"]),
      config: z.union([predefinedConditions, customConditions]),
    }),
  ),
  isValid: z.boolean().default(true),
});

export type BranchNodeSchema = z.infer<typeof branchNodeSchema>;

export const defaultBranchNodeValues: BranchNodeSchema = {
  nodeId: "",
  name: "",
  conditions: [
    {
      type: "predefined",
      config: {
        field: "",
        operator: "",
        value: "",
      },
    },
  ],
  isValid: true,
};
